import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute'; // Correct Path
import DashboardLayout from '../layouts/DashboardLayout'; // Correct Path
import Dashboard from '../pages/dashboard/Dashboard';
import NotFound from '../pages/404';
import OnsiteReport from '../pages/admin/OnsiteReports.js';


const AdminRoutes = () => {
  return (
    <ProtectedRoute>
      <DashboardLayout>
        <Routes>
          <Route path="" element={<Dashboard />} />
          
          <Route path="onsiteReports" element={<OnsiteReport />} />

          <Route path="river" element={<OnsiteReport />} />
          <Route path="stp" element={<OnsiteReport />} />
          <Route path="drains" element={<OnsiteReport />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </DashboardLayout>
    </ProtectedRoute>
  );
};

export default AdminRoutes;
